import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { fetchMissionById } from '../../services/pmissions.service';
import {  teacherFetchStudentMissions } from '../../services/pstudentMissions.service';
import { getStudentScore, getTotalScore } from '../../util/mission';
import DownloadReportPopup from '../primary_admin/components/DownloadReportPopup';


function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const [total, settotal] = useState(0)
    const [mission, setmission] = useState(null)

    const filter = searchParams.get('filter') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit =10
    const totalPage = Math.ceil(total / limit) || 1

    const handleSelectPage = (p) => async () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }

    const fetchData = async () => {
        const filter = { missionId:id }
        let result = await teacherFetchStudentMissions(props.token.token, filter, { limit, skip: (page - 1) * limit },id);
        if (result.result) {
            setdata(result.result)
            settotal(result.count || 0)
        } else {
            alert('Fetch data error')
        }
    }
       const fetchAllData = async () => {
            const filter = { missionId: id }
            let result = await teacherFetchStudentMissions(props.token.token, filter, { limit: 999 }, id);
            if (result.result) {
                return result.result||[]
            } else {
                alert('Fetch data error')
                return []
            }
        }

    const fetchMissionData = async () => {
        let result = await fetchMissionById(props.token.token, id);
        if (result.result) {
            setmission(result.result)
        } else {
            alert('Fetch data error')
        }
    }

    const refresh = async () => {
        setisLoading(true)
        fetchData()
        fetchMissionData()
        setisLoading(false)
    }

    const onSelectFilter = (item, index) => {
        searchParams.delete('filter')
        searchParams.delete('page')
        searchParams.set('filter', item)
        searchParams.set('page', 1)
        setSearchParams(searchParams)
    }

    useEffect(() => {
        const timer = setTimeout(refresh, 500)
        // const interval = setInterval(refresh, 1000 * 30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])

    const [showDownloadPopup, setShowDownloadPopup] = useState(false)

    return (
        <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]'>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
                <div className='text-[#212121] text-[20px] font-[700]'>閲讀任務名稱: {mission?.name}</div>
                <div className='flex flex-row items-center gap-[8px] flex-wrap'>
                    <button className='text-[blue] text-[12px] underline' onClick={() => {setShowDownloadPopup(true)}}>下載閱讀成績單</button>
                    <div className='cursor-pointer text-[blue] underline text-[12px]' onClick={()=>{navigate(`/platform/results/statistic/${id}`)}}>查看統計圖</div>
                    {/* <DropDownMenu select={onSelectFilter} value={filter} options={['全部', '1', '2', '3']} /> */}
                    {/* <div className='text-[14px] py-[8px] px-[16px] rounded-[7px] gap-[4px] flex flex-row' style={{ border: '.5px solid #00000080' }}>
                        <SearchSvg />
                        <input  placeholder='搜尋學生姓名' />
                    </div> */}
                </div>
            </div>
            {/*end of title, filter, serach box*/}


            {/*list of data*/}
            <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px] p-[16px] text-[14px]' style={{ overflowY: 'auto' }}>
                <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{ borderBottom: '1px solid #D1D1D1' }}>
                    <div className='flex-1'>學生姓名</div>
                    <div className='flex-1'>學生班級</div>
                    <div className='flex-1'>性別</div>
                    <div className='flex-1'>開始時間</div>
                    <div className='flex-1'>完成時間</div>
                    <div className='flex-1'>任務狀態</div>
                    <div className='flex-1'>分數</div>
                    {/* <div className='flex-1'>學生回答</div> */}
                    {/* <div className='flex-1'>問卷</div> */}
                    <div className='w-[32px]'></div>
                </div>
                {data?.map((item, index) =>
                    <div key={item?._id || index} className='w-full flex flex-row justify-between font-[400] py-[16px] items-center' style={{ borderBottom: '1px solid #D1D1D1' }}>
                        <div className='flex-1'>{item?.student?.name}</div>
                        <div className='flex-1'>{item?.student?.class}</div>
                        <div className='flex-1'>{item?.student?.gender}</div>
                        <div className='flex-1'>{item?.startTime? new Date(item?.startTime).toLocaleString():''}</div>
                        <div className='flex-1'>{item?.finishTime? new Date(item?.finishTime).toLocaleString():''}</div>
                        <div className='flex-1'>{item?.status}</div>
                        <div className='flex-1'>{getStudentScore(item?.questions)}/{getTotalScore(item?.questions)}</div>
                        {/* <div className='flex-1'>{item?.finishTime?'Y':"N"}</div> */}
                        {/* <div className='flex-1'>{item?.questionnaireFinishTime?'Y':'N'}</div> */}
                       
                        <div onClick={()=>{navigate(`/platform/studentmissions/${item?._id}`)}} className='w-[32px] bg-[#FFD8D0] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5]'>
                            <MoreSvg />
                        </div>
                    </div>
                )}
            </div>
            {/*end of list of data*/}
            <PageSelector
                handleSelectPage={handleSelectPage}
                page={page}
                total={total}
                totalPage={totalPage}
            />

             {showDownloadPopup && <DownloadReportPopup close={()=>{setShowDownloadPopup(false)}} fetch={fetchAllData}/>}
            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
